import {AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";

@Component({
    selector: 'otp',
    templateUrl: './otp.component.html',
    imports: [
        TranslateModule,
        CommonModule,
        FormsModule
    ],
    standalone:true,
    styleUrls: ['./otp.component.css']
})
export class PublicOtpComponent implements AfterViewInit {
    public verificationCode: string = "";
    @Output() public verificationCodeChange = new EventEmitter<string>();

    @ViewChild('code1') firstInputElement: ElementRef|undefined;

    public c1: string = "";
    public c2: string = "";
    public c3: string = "";
    public c4: string = "";
    public c5: string = "";
    public c6: string = "";

    ngAfterViewInit() {
        this.firstInputElement?.nativeElement.focus();
    }

    public keyDown(e: KeyboardEvent, p: HTMLInputElement|null, c: HTMLInputElement, n: HTMLInputElement|null) {
        let length = c.value.length;
        let maxLength = +c.getAttribute('maxlength')!;

        if(e.key === 'Backspace'){
            return;
        }

        if(length == maxLength) {
            if (!!n) {
                n.focus();
            }
        }

        this.verificationCode = this.c1+this.c2+this.c3+this.c4+this.c5+this.c6;

        if(this.verificationCode.length ==6){
            this.verificationCodeChange.emit(this.verificationCode);
            this.reset();
        }
    }

    public keyUp(e: KeyboardEvent, p: HTMLInputElement|null, c: HTMLInputElement, n: HTMLInputElement|null) {

        if(e.key === 'Backspace'){
            if(!!p){
                c.value = "";
                p.focus();
            }
        }

        this.verificationCode = this.c1+this.c2+this.c3+this.c4+this.c5+this.c6;

        if(this.verificationCode.length ==6){
            this.verificationCodeChange.emit(this.verificationCode);
            this.reset();
        }
    }

    private reset() {
        this.c1 = "";
        this.c2 = "";
        this.c3 = "";
        this.c4 = "";
        this.c5 = "";
        this.c6 = "";
        this.verificationCode = "";
        this.firstInputElement?.nativeElement.focus();
    }
}
